// extracted by mini-css-extract-plugin
export default {"openCategory":"OpenCategory_openCategory__5LLSW"};